"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PaginationWrapper", {
  enumerable: true,
  get: function get() {
    return _PaginationWrapper["default"];
  }
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));
var _utils = require("./utils");
var _PaginationDot = _interopRequireDefault(require("./PaginationDot"));
var _PaginationWrapper = _interopRequireDefault(require("./PaginationWrapper"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var DOT_SIZE = 18;
var Pagination = function Pagination(_ref) {
  var clickable = _ref.clickable,
    dotsColor = _ref.dotsColor,
    index = _ref.index,
    onChangeIndex = _ref.onChangeIndex,
    PaginationWrapper = _ref.paginationWrapper,
    slideCount = _ref.slideCount,
    visibleItems = _ref.visibleItems,
    maxNumberOfDots = _ref.maxNumberOfDots;
  var children = [];
  var fixedIndex = (0, _utils.setFixedIndex)(index, slideCount, maxNumberOfDots);
  for (var i = 0; i <= slideCount - visibleItems; i += 1) {
    children.push( /*#__PURE__*/_react["default"].createElement(_PaginationDot["default"], {
      clickable: clickable,
      color: dotsColor,
      hasMoreState: (0, _utils.setMoreState)(fixedIndex, i, slideCount, maxNumberOfDots),
      index: i,
      isActive: i === index,
      key: i,
      onClick: onChangeIndex
    }));
  }
  var numberOfDots = Math.min(slideCount, maxNumberOfDots);
  var sliderPadding = slideCount < maxNumberOfDots ? 0 : (numberOfDots - 1) / 2;
  var maxWidth = "".concat(DOT_SIZE * numberOfDots, "px");
  var styles = {
    slider: {
      maxWidth: maxWidth,
      padding: "0px ".concat(sliderPadding * DOT_SIZE, "px")
    },
    slide: {
      width: "".concat(DOT_SIZE, "px"),
      height: "".concat(DOT_SIZE, "px")
    }
  };
  return /*#__PURE__*/_react["default"].createElement(PaginationWrapper, null, /*#__PURE__*/_react["default"].createElement(_reactSwipeableViews["default"], {
    index: fixedIndex,
    style: styles.slider,
    slideStyle: styles.slide,
    disabled: true
  }, children));
};
Pagination.propTypes = process.env.NODE_ENV !== "production" ? {
  clickable: _propTypes["default"].bool,
  dotsColor: _propTypes["default"].string,
  index: _propTypes["default"].number,
  onChangeIndex: _propTypes["default"].func,
  paginationWrapper: _propTypes["default"].object,
  slideCount: _propTypes["default"].number,
  visibleItems: _propTypes["default"].number,
  maxNumberOfDots: _propTypes["default"].number
} : {};
Pagination.defaultProps = {
  paginationWrapper: _PaginationWrapper["default"],
  visibleItems: 1,
  maxNumberOfDots: 7
};
var _default = exports["default"] = Pagination;